import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { SectionHeader as SimbaSectionHeader } from '@naf-simba/sections-headers';

/**
 * Simba `SectionHeader` with top padding that clears the fixed navbar.
 * Simba renders the title as an `<h1>`, so the descendant override applies
 * (shared by all section-header surfaces — Hero, FAQ, SectionPage, nafCenter…).
 */
export const SectionHeader = styled(SimbaSectionHeader)`
  h1 {
    padding-top: ${spacing.space160};

    @media (max-width: ${breakpoints.l}) {
      padding-top: ${spacing.space120};
    }
    @media (max-width: ${breakpoints.m}) {
      // 95px: precise legacy mobile navbar clearance — no spacing token sits
      // between space80 and space120.
      padding-top: 95px;
    }
  }
`;
